import mapTeaser from '../../../../../../src/js/modules/mapTeaser';

window.addEventListener('load', () => {
    mapTeaser.init();
});
